import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { usd } from "@/components/ai/useAiEdits";
import { BudgetBar } from "./BudgetBar";
import { fmtN, pl } from "./helpers";

function Kpi({ label, value, sub, testid }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 min-w-0" data-testid={testid}>
      <p className="text-xs text-slate-500">{label}</p>
      <p className="mt-2 text-2xl font-semibold tracking-tight text-slate-900 tabular-nums truncate" data-testid={`${testid}-value`}>{value}</p>
      <p className="mt-1 text-[11px] leading-snug text-slate-500">{sub}</p>
    </div>
  );
}

function MonthBudget({ b }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-navy-900 text-white p-5 flex flex-col" data-testid="costs-month-budget">
      <p className="text-xs text-slate-400">Budget mensile AI · mese in corso</p>
      <p className="mt-2 text-3xl font-semibold tracking-tight tabular-nums" data-testid="costs-month-spent">{usd(b.month_spent)}</p>
      <p className="text-[11px] text-slate-400">{b.month_budget ? `su ${usd(b.month_budget)} di budget` : "Nessun budget mensile impostato"}</p>
      {b.month_budget && <div className="mt-4 [&_span]:text-slate-300"><BudgetBar spent={b.month_spent} budget={b.month_budget} warn={b.warn_pct} testid="costs-month-bar" /></div>}
      {b.warn && <p className="mt-3 flex items-start gap-1.5 text-[11px] text-amber-300" data-testid="costs-month-warn"><AlertTriangle size={13} className="shrink-0" />Superato l'{b.warn_pct}% del budget: le operazioni oltre il budget verranno bloccate.</p>}
      <Link to="/settings" className="mt-auto pt-4 text-[11px] text-sky-300 hover:text-sky-200" data-testid="costs-budget-settings-link">Modifica limiti e budget →</Link>
    </div>
  );
}

export default function KpiCards({ sum }) {
  const t = sum.totals;
  const o = sum.operations;
  return (
    <div className="grid gap-4 lg:grid-cols-3" data-testid="costs-kpis">
      <div className="grid gap-4 sm:grid-cols-2 lg:col-span-2">
        <Kpi label="USD stimati nel periodo" value={usd(t.usd)} sub={`${pl(t.calls, "chiamata AI", "chiamate AI")} · ${pl(t.failed, "fallita", "fallite")}`} testid="kpi-usd" />
        <Kpi label="Token elaborati" value={`${fmtN(t.input_tokens)} in`} sub={`${fmtN(t.output_tokens)} token out · ${pl(t.images, "immagine AI", "immagini AI")}`} testid="kpi-tokens" />
        <Kpi label="Consuntivo rispetto alla stima" value={o.ratio ? `${Math.round(o.ratio * 100)}%` : "—"} testid="kpi-accuracy"
          sub={o.done ? `${pl(o.done, "operazione completata", "operazioni completate")}: stimati ${usd(o.estimated_usd)}, consuntivo ${usd(o.actual_usd)}` : "Nessuna operazione completata nel periodo"} />
        <Kpi label="Operazioni AI" value={fmtN(o.count)} sub={`${pl(o.done, "completata", "completate")} · ${pl(o.cancelled, "interrotta", "interrotte")} · ${o.errors} con errore`} testid="kpi-ops" />
      </div>
      <MonthBudget b={sum.budget} />
    </div>
  );
}
